import LoadingScreen from '../components/LoadingScreen';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function SuperAdminChatsScreen() {
  const navigate = useNavigate();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.chat.conversations()
      .then(data => setConversations(data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = async (item) => {
    if (!window.confirm(`Удалить переписку с ${item.user_name}?`)) return;
    await api.chat.deleteConversation(item.user_id);
    setConversations(prev => prev.filter(c => c.user_id !== item.user_id));
  };

  if (loading) return <LoadingScreen />;

  return (
    <div style={{ paddingBottom: 100 }}>
      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', background: 'var(--card)' }}>
        <h1 style={{ fontWeight: 700, fontSize: 17 }}>💬 Сообщения клиентов</h1>
      </div>

      {conversations.length === 0 ? (
        <div style={centered}>
          <span style={{ fontSize: 48 }}>📭</span>
          <p style={{ color: 'var(--text-light)', marginTop: 12 }}>Пока нет сообщений</p>
        </div>
      ) : conversations.map(item => (
        <div key={item.user_id}
          onClick={() => navigate(`/superadmin-chat/${item.user_id}`, { state: { userName: item.user_name } })}
          style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', background: 'var(--card)', borderBottom: '1px solid var(--border)', gap: 12, cursor: 'pointer' }}>
          <div style={{ width: 48, height: 48, borderRadius: 24, background: 'rgba(26,109,181,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: 'var(--primary)', fontSize: 20, flexShrink: 0 }}>
            {(item.user_name?.[0] || '?').toUpperCase()}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 600, fontSize: 15 }}>{item.user_name}</span>
              <span style={{ fontSize: 12, color: 'var(--text-light)' }}>
                {new Date(item.last_time).toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.last_text}</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {item.unread > 0 && (
              <span style={{ minWidth: 20, height: 20, borderRadius: 10, background: 'var(--primary)', color: '#fff', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px' }}>
                {item.unread}
              </span>
            )}
            <button onClick={e => { e.stopPropagation(); handleDelete(item); }}
              style={{ background: 'none', color: '#FF3B30', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: '4px 8px' }}>
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

const centered = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh' };
